import { AUTOMATION_STAGE_STATUSES } from '../genericAutomationStageStatuses'

export const STRAVA_AUTOMATION_STAGE_STATUSES = {
  ...AUTOMATION_STAGE_STATUSES,
}
